import {Component, Input, OnInit} from '@angular/core';
import {ExgModalService} from 'exc-controls-v2';
import {ApplicationService} from '../../services/application.service';
import {ExcTranslation} from 'exc-core-v2';

@Component({
  selector: 'app-modal-oe-questionnaire',
  templateUrl: './modal-oe-questionnaire.component.html',
  styles: [
  ]
})
export class ModalOeQuestionnaireComponent extends ExcTranslation implements OnInit {
  @Input() data: any;

  dataModel: any = {
    qcfgName: '',
    qcfgIsDraft: true
  };
  dataModelClone: any;

  constructor(
    private modalSvc: ExgModalService,
    private appSvc: ApplicationService
  ) {
    super();
  }

  ngOnInit(): void {

    if (!this.data) {
      this.dataModelClone = this.appSvc.helperObj.clone(this.dataModel);
    } else {
      this.dataModelClone = this.appSvc.helperObj.clone(this.data);
      this.dataModel = this.appSvc.helperObj.clone(this.data);
    }
    console.log(this.dataModelClone);
  }

  delete(): void {
    this.modalSvc.action({
      qcnfID: this.dataModelClone?.qcnfID,
      qcfgUPT: this.dataModelClone?.qcfgUPT,
      del: true
    });
  }

  cancel(): void {
    this.close();
  }

  close(): void {
    this.modalSvc.close();
  }

  save(): void {
    if (this.appSvc.helperObj.changed(this.dataModel, this.dataModelClone)) {
      if (this.dataModelClone.qcfgName && this.dataModelClone.qcfgName.length > 0) {
        this.modalSvc.action(this.dataModelClone);
      }
    }
  }
}
